const weekViewWrapper = {
    display: "flex"
}

const datesLabel: any = {
    textAlign: "center",
    position: "relative"
}

const arrowHeader = {
    width: 1,
    cursor: "pointer"
}

const frwdIconStyle = {
    transform: "rotate(180deg)",
};

export {
    weekViewWrapper,
    datesLabel,
    arrowHeader,
    frwdIconStyle
}